import React from 'react';
import { Link } from 'react-router-dom'; // Assure-toi d'utiliser React Router dans ton app
import './InfoFooter.scss';

const InfoFooter: React.FC = () => (
  <footer className="infoFooter">
    <div className="infoFooterContainer">
      <div className="infoFooterCol infoFooterBrand">
        <div className="infoFooterTitle">ReviewBoost AI</div>
        <div className="infoFooterDesc">
          ReviewBoost AI – Gérez vos avis clients intelligemment grâce à l'IA.
        </div>
      </div>
     <div className="infoFooterCol infoFooterLinks">
  <div className="infoFooterNavTitle">Légal</div>
  <ul className="infoFooterNavList">
    <li>
      <Link className="infoFooterNavLink" to="/legal/privacy-policy">Politique de confidentialité</Link>
    </li>
    <li>
      <Link className="infoFooterNavLink" to="/legal/cookies-policy">Politique de cookies</Link>
    </li>
    <li>
      <Link className="infoFooterNavLink" to="/legal/cgu">Conditions d’utilisation</Link>
    </li>
    <li>
  <Link className="infoFooterNavLink" to="/legal/request-data">
    Exercer mes droits RGPD
  </Link>
</li>
<li>
    <Link className="infoFooterNavLink" to="/legal/payments-billing">
      Abonnements & paiements
    </Link>
  </li>
  </ul>
</div>

    </div>
  </footer>
);

export default InfoFooter;
